export default __webpack_public_path__ + "static/media/popup_image_mobile.9290f0b5.png";